import { useEffect } from 'react';
import { useNetworkStatus } from './useNetworkStatus';
import { syncService } from '@/services/sync-service';
import { useAuth } from '@/contexts/AuthContext';
import { useToast } from './use-toast';
import { logger } from '@/lib/logger';

export const useAutoSync = () => {
  const { user } = useAuth();
  const networkStatus = useNetworkStatus();
  const { toast } = useToast();

  useEffect(() => {
    if (!user) return;

    if (networkStatus.isOnline) {
      logger.info('Connection restored, attempting auto-sync');
      
      syncService.syncPendingRuns(user.id)
        .then(result => {
          if (result.success > 0) {
            toast({
              title: "✅ Corridas Sincronizadas",
              description: `${result.success} corrida${result.success > 1 ? 's foram' : ' foi'} enviada${result.success > 1 ? 's' : ''} com sucesso`,
              duration: 5000
            });
          }

          if (result.failed > 0) {
            toast({
              title: "⚠️ Algumas corridas falharam",
              description: `${result.failed} corrida${result.failed > 1 ? 's' : ''} não puderam ser sincronizada${result.failed > 1 ? 's' : ''}`,
              variant: "destructive",
              duration: 7000
            });
          }
        })
        .catch(error => {
          logger.error('Auto-sync failed', error);
        });
    }
  }, [networkStatus.isOnline, user, toast]);
};
